export default __webpack_public_path__ + "static/orangeloop-52-4b6967fc7cdd64f6a3379256ff6c6529.jpg";